import Dispatcher from "../dispatcher";
import BookStore from "./book-store";
import BookmarkUtils from "../utils/bookmark-utils";
import { toastUtils } from "../utils/toast-utils";

const BookmarkStore = {
  _state: {},

  isLoading: false,

  // get bookmark by book and syncId
  // TODO maybe this could be better/updated to search regardless of book?
  get(isbn, guid) {
    return this.getAll(isbn).find(bookmark => {
      return bookmark.guid === guid;
    });
  },

  // get all bookmarks for a book
  // TODO allow no book to return entire object?
  getAll(isbn) {
    let bookmarks = this._state[isbn];
    // TODO init the bookmark object - right now the book controls this
    bookmarks = this._state[isbn] = bookmarks || this._getBlank(isbn);
    return bookmarks;
  },

  _getBlank(isbn) {
    let store = this;
    return {
      isbn: isbn,
      _updateState: function(state) {
        store._updateState(this.isbn, state);
      }
    };
  },

  _updateState(isbn, state) {
    // TODO
    this._state[isbn] = $.extend(this._state[isbn], state);
    Dispatcher.emit(Dispatcher.BOOKMARKS_CHANGE, isbn);
  },

  _load(isbn) {
    let book = BookStore.get(isbn);
    let bookmarks = this.getAll(isbn);
    if (book.viewer && !bookmarks.bookmarksLoading && book.viewerIsReady) {
      bookmarks._updateState({ bookmarksLoading: true });
      book.viewer.Book.getBookmarks(response => {
        if (response.isSuccess()) {
          bookmarks._updateState({
            bookmarks: this.filterBookmarks(response.data.bookmarks),
            bookmarksLoading: false
          });
        } else {
          bookmarks._updateState({
            bookmarksLoading: false,
            bookmarks: []
          });

          // TODO maybe not the right error here :/
          Fraction.Helpers.toast(
            i18n.t("reader.notebook.notes-highlights-error"),
            { type: "error", dismissable: true }
          );
        }
      });
    }
  },

  // Convert bookmarks into a data format the menulist can handle
  filterBookmarks(bookmarks) {
    let newBookmarks = [];
    $.each(bookmarks, (key, value) => {
      newBookmarks.push(this.filterBookmark(value));
    });

    // Sort by page number after filtering
    newBookmarks = this.sortBookmarks(newBookmarks);

    return newBookmarks;
  },

  filterBookmark(bookmark) {
    bookmark.date = Date.parse(bookmark.markedAt);
    return bookmark;
  },

  sortBookmarks(bookmarks) {
    function compareBookmarks(a, b) {
      var aValue = a.page;
      var bValue = b.page;

      // If we can successfully do it, convert string to a number
      if (!isNaN(parseInt(aValue, 10))) {
        aValue = parseInt(aValue, 10);
      } else if (!isNaN(parseInt(bValue, 10))) {
        bValue = parseInt(bValue, 10);
      }

      // Sort alphabetic pages (ex. xxvii) before numeric ones (ex. 93)
      if (isNaN(parseInt(aValue, 10)) && !isNaN(parseInt(bValue, 10))) {
        return -1;
      } else if (isNaN(parseInt(bValue, 10)) && !isNaN(parseInt(aValue, 10))) {
        return 1;
      }

      // Normal compare for either number-to-number or string-to-string
      if (aValue < bValue) {
        return -1;
      } else if (aValue > bValue) {
        return 1;
      } else {
        return 0;
      }
    }

    return bookmarks.sort(compareBookmarks);
  },

  _addBookmark(isbn) {
    let book = BookStore.get(isbn);

    // Ideally we'd do this check on the server, but for now check if we already
    // made a bookmark with the same page number
    if (BookmarkUtils.bookmarkExists(isbn)) {
      toastUtils.notify(i18n.t("bookmarks.bookmark-already-exists"), {
        type: "error"
      });
      Dispatcher.emit(Dispatcher.BOOKMARKS_ACTION_FAILED, isbn);
      return false;
    }

    let bookmarkObj = this.getAll(isbn);
    book.viewer.Book.setBookmark(response => {
      if (response.isSuccess()) {
        // TODO move this
        toastUtils.notify(i18n.t("bookmarks.bookmark-added"), {
          type: "success"
        });

        let bookmark = response.data.bookmark;
        let filteredBookmark = this.filterBookmark(bookmark);
        bookmarkObj._updateState({
          bookmarks: this.sortBookmarks(
            bookmarkObj.bookmarks.concat(filteredBookmark)
          )
        });
      } else {
        // TODO move this
        toastUtils.notify(i18n.t("bookmarks.bookmark-already-exists"), {
          type: "error"
        });
      }
    });
  },

  _deleteBookmark(isbn, guid) {
    // TODO Remove bookmark from local data (then call api, faster UI update this way)
    let book = BookStore.get(isbn);
    let bookmarkObj = this.getAll(isbn);
    book.viewer.Book.deleteBookmark(guid, response => {
      // TODO remove this from here
      for (let i = 0; i < bookmarkObj.bookmarks.length; i++) {
        if (bookmarkObj.bookmarks[i].guid === guid) {
          bookmarkObj.bookmarks.splice(i, 1);
          // still update the state so the bookmark change emit is called
          bookmarkObj._updateState({
            bookmarks: bookmarkObj.bookmarks
          });
          return false;
        }
      }
      Fraction.Helpers.toast(i18n.t("bookmarks.bookmark-deleted"));
    });
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 2);
    Dispatcher.bind(Dispatcher.BOOKMARKS_ADD, isbn => {
      this._addBookmark(isbn);
    });
    Dispatcher.bind(Dispatcher.BOOKMARKS_DELETE, (isbn, guid) => {
      this._deleteBookmark(isbn, guid);
    });
  }
};

BookmarkStore.init();

export default BookmarkStore;
